import { get, getOr, find, isEmpty } from 'lodash/fp';
import { parseInt } from '../utils';

export default (guestInfo, limitRules) => {
  if (!limitRules || isEmpty(limitRules)) return 0;

  const isHomeless = parseInt(get('homeless', guestInfo)) === 1;
  if (isHomeless) {
    const homelessRule = find({ key: 'NR' }, limitRules);
    return getOr(0, 'quantity', homelessRule);
  }

  const householdRule = find({ key: 'HH' }, limitRules);
  if (householdRule) {
    return getOr(0, 'quantity', householdRule);
  }

  const householdTotal = getOr(1, 'householdTotal', guestInfo);

  const rules = find(each => {
    const from = parseInt(each.from);
    return (
      householdTotal >= from &&
      (each.to === '+' || householdTotal <= parseInt(each.to))
    );
  }, limitRules);

  return getOr(0, 'quantity', rules);
};
